<!-- 
ContScoreModal.vue
功能：親疏等級說明視窗
作者：i94005pi01 周厚鈞
完成：2022-12-20
-->
<template>
  <div id="cont-score-modal" class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog" style="width: 800px;">
      <div class="modal-content">
        <div class="modal-header">
          <a @click="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>
          <div>
            <span class="cathay-cust-info-title text-green">親疏等級</span>
            <div class="padding-top-use font-weight-bold font-20">
              <span>快速了解與客戶的親疏程度，協助您安排每工最適當拜訪策略。</span>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="insurance-row row d-flex">
            <table id="cathay-cust-info-text" class="table datatable flex-fill mr-4">
              <thead>
                <tr>
                  <th style="width: 20%;" class="text-center">親疏等級</th>
                  <th style="width: 80%;" class="text-center">應用說明</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>核心客戶</td>
                  <td>與客戶密切聯繫，拜訪頻繁，落實各項實質接觸項目。</td>
                </tr>
                <tr>
                  <td>經營中客戶</td>
                  <td>與客戶聯繫程度普通，實質接觸項目完成度低於核心客戶。</td>
                </tr>
                <tr>
                  <td>疏遠客戶</td>
                  <td>與客戶關係疏遠，拜訪頻率低，BOX紀錄較少。</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row mt-2 mb-4 d-flex justify-content-end">
            <a v-if="!surveyIsComplete"
              class="btn btn-border-green"
              @click="openSurveyModal()"
            >我要回饋親疏等級</a>
            <a v-if="surveyIsComplete"
              class="btn btn-border-green"
              @click="openSurveyModal()"
            >已完成回饋</a>
          </div>
          <div class="insurance-row row">
            <div class="div-margin-left">
              <span>註：關係分數將於每季更新，於每季第一個曆月第3個工作天更新，計算期間為更新當季往前推算兩年。</span>
            </div>
            <div class="div-margin-left">
              <span>ex：112Q2之關係分數計算期間為110Q2-112Q1</span>
            </div>
            <div class="padding-top-use div-margin-left text-green">
              <div v-for="(item, index) in memo" :key="`memo-${index}`">
                <span>{{
                  `${item.description + item.contact}分機${item.contact_tel}`
                }}</span>
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commonMixin } from "@/mixins/common";
import { getContactInfo } from "@/service";
import { getSurveyInfo } from "@/service";
export default {
  name: "ContScoreModal",
  mixins: [commonMixin],
  props: {
    open: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => {
        return [];
      }
    },
    custId: {
      type: String,
      default: ""
    },

  },
  data() {
    return {
      memo: [],
      surveyNo: '003', //查詢問券是否已完成
      surveyIsComplete: false
    };
  },
  methods: {
    //開啟問券視窗
    openSurveyModal() {
      this.$emit('close');
      this.$emit('openSurveyModal');
    },
  },
  mounted() {
    getContactInfo(this.$store.state.userInfo.id, "親疏等級").then(
      (result) => {
        if (result.header && result.header.status === "200") {
          this.memo = result.body.data;
        }
      }
    );
    getSurveyInfo(this.$store.state.userInfo.id, this.custId, this.surveyNo).then(
      (result) => {
        if (result.header && result.header.status === "200") {
          if("Y" === result.body.is_complete)
            this.surveyIsComplete = true;
          else  
            this.surveyIsComplete = false;
        }
      }
    );
  },
};
</script>
<style lang="scss" scoped>
.cathay-cust-info-title {
  font-size: 30px;
  font-weight: 600;
  margin-bottom: 0.5rem;
  margin-right: 0.5rem;
  font-family: inherit;
  line-height: 1.2;
}

.padding-top-use {
  padding-top: 1.5rem;
}

.text-center {
  text-align: center;
}

.table.datatable {
  width: 90%;
  margin-left: 1.2rem;
  tbody {
    tr > td {
      &:first-child {
        padding-top: 10px;
      }
    }
  }
}

.div-margin-left {
  margin-left: 1.2rem;
}

.font-20 {
  font-size: 20px;
}

.modal-body {
  min-height: 300px !important;
  padding: 20px 40px;
}
</style>